const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bags-shopping"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8 14.4C8 13.5599 8 13.1399 8.16349 12.819C8.3073 12.5368 8.53677 12.3073 8.81901 12.1635C9.13988 12 9.55992 12 10.4 12H19.6C20.4401 12 20.8601 12 21.181 12.1635C21.4632 12.3073 21.6927 12.5368 21.8365 12.819C22 13.1399 22 13.5599 22 14.4V18.6C22 19.4401 22 19.8601 21.8365 20.181C21.6927 20.4632 21.4632 20.6927 21.181 20.8365C20.8601 21 20.4401 21 19.6 21H10.4C9.55992 21 9.13988 21 8.81901 20.8365C8.53677 20.6927 8.3073 20.4632 8.16349 20.181C8 19.8601 8 19.4401 8 18.6V14.4Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M18 15C18 16.6569 16.6569 18 15 18C13.3431 18 12 16.6569 12 15",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M7 7V6C7 4.34315 8.34315 3 10 3C11.6569 3 13 4.34315 13 6V6.97545",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_4",
    d: "M18 9V9C18 7.89543 17.1046 7 16 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V16C2 17.1046 2.89543 18 4 18V18",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrders);
export default __webpack_public_path__ + "static/media/icon_orders.97c33731893ebe68c1e8e50659966bd2.svg";
export { ForwardRef as ReactComponent };